


































































































































import {
  createComponent,
  inject,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import v8n from "@/lib/v8n";
import CompanyKey from "@/components/company-key";
import boxLinkSvg from "@/assets/svg/boxLink.svg";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const companyStore = inject(CompanyKey);
    if (!companyStore) {
      throw new Error(`${CompanyKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);
    const classList = computed(() => companyStore.classList);
    const pepList = computed(() => companyStore.pepList);

    const companyAddParams = computed(() => companyStore.companyAddParams);
    const companyAddParamsErrorFlag = computed(
      () => companyStore.companyAddParamsErrorFlag
    );
    const companyAddParamsErrorMessage = computed(
      () => companyStore.companyAddParamsErrorMessage
    );

    // input
    const inputCompanyAddParamsCompany = (e: any) => {
      companyStore.inputCompanyAddParamsCompany(e);
      if (isConfirmButtonClicked.value) {
        companyStore.validateCompanyAddParams();
      }
    };
    const inputCompanyAddParamsDepartment = (e: any) => {
      companyStore.inputCompanyAddParamsDepartment(e);
      if (isConfirmButtonClicked.value) {
        companyStore.validateCompanyAddParams();
      }
    };
    const inputCompanyAddParamsEmployeeNumber = (e: any) => {
      companyStore.inputCompanyAddParamsEmployeeNumber(e);
      if (isConfirmButtonClicked.value) {
        companyStore.validateCompanyAddParams();
      }
    };
    const inputCompanyAddParamsEmployeeClassification = (e: any) => {
      companyStore.inputCompanyAddParamsEmployeeClassification(e);
      if (isConfirmButtonClicked.value) {
        companyStore.validateCompanyAddParams();
      }
    };
    const inputCompanyAddParamsPeps = (e: any) => {
      companyStore.inputCompanyAddParamsPeps(e);
      if (isConfirmButtonClicked.value) {
        companyStore.validateCompanyAddParams();
      }
    };

    // validation
    const isConfirmButtonClicked = ref(false);

    const confirm = () => {
      isConfirmButtonClicked.value = true;

      if (!companyStore.validateCompanyAddParams()) {
        return;
      }

      companyStore.saveCompanyAddParams();
      context.root.$router.push({ name: "CompanyAddConfirm" });
    };

    const back = () => {
      context.root.$router.push({ name: "CompanyAddAgree" });
    };

    return {
      companyAddParams,
      companyAddParamsErrorFlag,
      companyAddParamsErrorMessage,
      classList,
      pepList,

      // input
      inputCompanyAddParamsCompany,
      inputCompanyAddParamsDepartment,
      inputCompanyAddParamsEmployeeNumber,
      inputCompanyAddParamsEmployeeClassification,
      inputCompanyAddParamsPeps,

      confirm,
      back
    };
  },
  components: {
    boxLinkSvg
  }
});
